import React, { useState } from 'react';
import { Segmented } from '../design/shared';
import { toLocalISO, toInputDate } from '../utils/dates';
import DatePicker from './DatePicker';

export default function EditTransaction({ tx, categories, onSave, onClose }) {
  const [description, setDesc] = useState(tx.description);
  const [amount, setAmt] = useState(tx.amount);
  const [category, setCat] = useState(tx.category);
  const [type, setType] = useState(tx.type);
  const [date, setDate] = useState(toInputDate(tx.date));
  const [isRecurring, setIsRecurring] = useState(tx.isRecurring || false);
  const [recurrenceType, setRecurrenceType] = useState(tx.recurrenceType || 'monthly');

  const handleSave = () => {
    if (!description || !amount) return;
    onSave(tx.id, {
      ...tx,
      description,
      amount: parseFloat(amount),
      category,
      type,
      date: toLocalISO(date),
      isRecurring,
      recurrenceType: isRecurring ? recurrenceType : '',
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
      <Segmented
        options={[
          { value: 'expense', label: 'Expense' },
          { value: 'income', label: 'Income' },
          // Money handed back by a merchant. Kept in the spending lens as a
          // credit, so a return releases the budget its purchase consumed —
          // and so the user can correct a card credit the sync read wrong.
          { value: 'refund', label: 'Refund' },
        ]}
        value={type}
        onChange={setType}
      />
      <input className="field" type="text" placeholder="Description" value={description} onChange={(e) => setDesc(e.target.value)} />
      <input className="field" type="number" placeholder="Amount" value={amount} onChange={(e) => setAmt(e.target.value)} step="0.01" />
      <DatePicker className="field" value={date} onChange={(val) => setDate(val)} />
      <select className="field" value={category} onChange={(e) => setCat(e.target.value)}>
        {categories.map((c) => <option key={c}>{c}</option>)}
      </select>
      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 13, color: 'var(--ink-2)', cursor: 'pointer', padding: '4px 0' }}>
        <input type="checkbox" checked={isRecurring} onChange={(e) => setIsRecurring(e.target.checked)} style={{ width: 16, height: 16, accentColor: 'var(--accent)' }} />
        Recurring
      </label>
      {isRecurring && (
        <select className="field" value={recurrenceType} onChange={(e) => setRecurrenceType(e.target.value)}>
          {['daily', 'weekly', 'biweekly', 'monthly', 'semiannual', 'yearly'].map((r) => (
            <option key={r} value={r}>{r === 'semiannual' ? 'Semi-annual' : r.charAt(0).toUpperCase() + r.slice(1)}</option>
          ))}
        </select>
      )}
      <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
        <button onClick={onClose} className="btn-quiet is-block pressable">
          Cancel
        </button>
        <button onClick={handleSave} className="btn-primary is-block pressable" style={{ flex: 2 }}>
          Save
        </button>
      </div>
    </div>
  );
}
